import cx from 'classnames'
import { useTranslation } from 'react-i18next'
import { useDisableScroll } from 'hooks'

import { unWei } from 'lib/helpers'
import { useModal } from 'store/slices/modals'

import { useEMPLDetails } from 'features/Bag/useBagDetails'

import TokenDisplay from 'components/Token/TokenDisplay'
import PurchaseEMPL from 'components/PurchaseEMPL'
import withOTPVerification from '../OTPModal/withOTPVerification'

type PurchaseEMPLData = {}

export const usePurchaseEMPLModal = () =>
  useModal<PurchaseEMPLData>('PurchaseEMPLModal')

const PurchaseEMPLModal = () => {
  const { t } = useTranslation()

  const buyEmplModal = usePurchaseEMPLModal()
  const emplDetailsRes = useEMPLDetails()

  const onClose = buyEmplModal.onClose
  const budget = unWei(Number(emplDetailsRes?.data?.empl?.unlocked))

  useDisableScroll(buyEmplModal.isActive)

  const onSuccess = () => {
    onClose()
    window.location.reload()
  }

  return (
    <div
      className={cx('Modal PurchaseEMPLModal', {
        'Modal--active': buyEmplModal.isActive,
      })}
    >
      <div className="Modal__overlay" />
      {buyEmplModal.isActive && (
        <div className="Modal__wrapper Modal__wrapper--auto-h">
          <div className="Modal__header Modal__header--bdrz-t">
            <a className="Modal__header__close" onClick={() => onClose()} />

            <h2 className="Modal__header__h2">{t('empl.buy_empl')}</h2>

            <TokenDisplay type="empl">{budget.toLocaleString()}</TokenDisplay>
          </div>
          <div className="Modal__body">
            <PurchaseEMPL onSuccess={onSuccess} />
          </div>
        </div>
      )}
    </div>
  )
}

export default withOTPVerification(PurchaseEMPLModal, usePurchaseEMPLModal)
